    <form *ngIf="templateFormGroup" [formGroup]="templateFormGroup">
        <p-card class="p-3" header="Datos generales">

            <div class="grid">
                <div class="col-6 input-field">
                    <label for="name">Nombre *</label>
                    <input pInputText formControlName="name" d-form-field-error />
                </div>
                <div class="col-3 input-field">
                    <label for="templateType">Tipo plantilla *</label>
                    <p-dropdown formControlName="templateType" [options]="templateTypes" optionLabel="label"
                        optionValue="value" [filter]="true" filterBy="label" placeholder="Selecciona un tipo"
                        d-form-field-error></p-dropdown>
                </div>
                <div class="col-3 input-field" *ngIf="templateFormGroup.get('templateType')?.value!='CaseLog'">
                    <label for="templateDestinationType">Dirigido para</label>
                    <p-dropdown formControlName="templateDestinationType" [options]="templateDestinationTypes" optionLabel="label"
                        optionValue="value" [filter]="true" filterBy="label" placeholder="Selecciona un destino"
                        d-form-field-error></p-dropdown>
                </div>
                <div class="col-4 input-field" *ngIf="templateFormGroup.get('templateType')?.value=='Document'">
                  <label for="typeOfDocument">Formato de documento *</label>
                    <p-dropdown formControlName="typeOfDocument" [options]="typeOfDocuments" optionLabel="label"
                        optionValue="value" [filter]="true" filterBy="label" placeholder="Selecciona un tipo de documento"
                        d-form-field-error></p-dropdown>
                </div>
                <div class="col-4 input-field" *ngIf="templateFormGroup.get('templateType')?.value=='Document'">
                    <label for="documentType">Tipo de documento *</label>
                    <p-dropdown formControlName="documentType" [options]="documentTypes" optionLabel="label"
                        optionValue="value" [filter]="true" filterBy="label" placeholder="Selecciona un tipo de documento"
                        d-form-field-error></p-dropdown>
                </div>
                
                <div class="col-12 input-field" *ngIf="templateFormGroup.get('templateType')?.value=='Email'">
                    <label for="subject">Asunto</label>
                    <input pInputText formControlName="subject" d-form-field-error />
                </div>
                <div class="col-12 input-field" *ngIf="templateFormGroup.get('templateType')?.value=='Email'">
                    <label for="content">Mensaje</label>
                    <editor [init]="init" formControlName="content" d-form-field-error />
                </div>
                <div class="col-12 input-field" *ngIf="templateFormGroup.get('templateType')?.value=='Whatsapp'">
                  <label for="content">Twilio Content SID</label>
                  <input pInputText  formControlName="contentSID" placeholder="Ej: HXxxxx" (change)="onContentSidChange()" d-form-field-error />
                  <small *ngIf="templateFormGroup.get('templateType')?.value=='Whatsapp'">*Nota: identificador de la plantilla de twilio.</small>
                </div>
                <div class="col-12 input-field" *ngIf="templateFormGroup.get('templateType')?.value=='SMS' || templateFormGroup.get('templateType')?.value=='Whatsapp' || templateFormGroup.get('templateType')?.value=='CaseLog'">
                    <label for="content">Mensaje</label>
                    <textarea pInputTextarea rows="5" formControlName="content" d-form-field-error [readonly]="templateFormGroup.get('templateType')?.value=='Whatsapp'"></textarea>
                    <small *ngIf="templateFormGroup.get('templateType')?.value=='Whatsapp'">*Nota: las plantillas de Whatsapp no son editables, debe configurarlas en la interface de Twilio.</small>
                </div>

                <div class="col-12" *ngIf="templateFormGroup.get('templateType')?.value=='Whatsapp'">
                  <div class="input-field" *ngFor="let field of this.template.templateConfig.fields; let i = index">
                    <label for="content">Variable {{i+1}}</label>
                    <input pInputText [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" d-form-field-error />
                  </div>
                </div>

               
                <div class="col-12 flex align-items-center" *ngIf="templateFormGroup.get('templateType')?.value=='Document' && templateFormGroup.get('typeOfDocument')?.value=='file'">
                    <!--<p-button *ngIf="allowWrite" label="Añadir archivo" icon="pi pi-plus" (click)="anyadirTemplateFile(null)" />-->
                    
                    <p-fileUpload mode="basic" accept=".doc,.docx" chooseIcon="pi pi-upload" (onSelect)="onFileSelect($event)" [multiple]="false"  chooseLabel="Seleccionar fichero" />
                    <p-button *ngIf="template.file != null"  [link]="true"  (onClick)="downloadFile(template.fileId)" > {{template.file.fileName}}&nbsp;<i class="pi pi-download"></i></p-button>
                    </div>
                </div>
                <div class="col-12 input-field" *ngIf="templateFormGroup.get('templateType')?.value=='Document' && templateFormGroup.get('typeOfDocument')?.value=='html'">
                  <label for="content">HTML del document</label>
                  <editor [init]="init" formControlName="content" d-form-field-error />
                </div>
            <div class="mt-4 flex gap-2">
                <p-button label="Eliminar" *ngIf="allowDelete && template?.id" icon="pi pi-trash"
                    styleClass="p-button-danger" (click)="delete()"></p-button>
                <div class="flex-grow-1"></div>
                <p-button *ngIf="templateFormGroup.get('templateType')?.value=='Document'" label="Ayuda" icon="pi pi-info-circle" styleClass="p-button-info" (click)="help()"></p-button>
                <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
                <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                    (click)="save()"></p-button>
            </div>
        </p-card>

        <p-tabView *ngIf="template.id&&templateFormGroup.get('templateType')?.value=='Document'">
                    
            <p-tabPanel header="Compañías" >
              <div class="flex justify-content-end pb-1">
                <p-button label="Añadir compañía" (click)="addCompany({}, false)" styleClass="p-button-sm"
                  *ngIf="allowWrite"></p-button>
              </div>
              <p-table styleClass="mt-4" [value]="companies" [paginator]="true" [rows]="25"
                [totalRecords]="totalCompaniesRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body"
                dataKey="companyId" rowGroupMode="subheader" groupRowsBy="companyId"
                >
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th pSortableColumn="company">Compañía <p-sortIcon field="company"></p-sortIcon></th>
                    <th >Contrato </th>
                    <th width="100"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-company let-columns="columns">
                  <tr>
                    <td>                    
                        {{company.companyId != null?company.company?.name: "Todas"}}
                    </td>
                    <td>
                      {{company.contractId != null?company.contract?.name: "Todos"}}
                  </td>
                    <td>
                      <div class="flex gap-2 justify-content-end">
                        <p-button *ngIf="allowDelete" (click)="deleteCompany(company)" [rounded]="true"
                          styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="2">
                      No se han encontrado compañías
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </p-tabPanel>            
          </p-tabView>
    </form>

<p-confirmDialog></p-confirmDialog>